import React, { useState, useEffect, Fragment, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Card } from 'react-bootstrap'
import Pagination from '../../components/Nav/Pagination'
import configs from '../../config'
import Cookies from 'js-cookie'
import Search from './Search'
import LotteryList from './LotteryList'
import UserModal from '../User/UserModal'
import UserInfo from './UserInfo'
import { useHistory } from 'react-router-dom'
import Swal from 'sweetalert2'

const LotteryLive = () => {
  const dispatch = useDispatch()
  const history = useHistory()
  const { roundDate } = useSelector((state) => state.webConfig)
  const [lotteries, setLotteries] = useState([])
  const [currentPage, setCurrentPage] = useState(1)
  const [searchText, setSearchText] = useState('')
  const [status, setStatus] = useState('ALL')
  const [digitsSearchType, setDigitsSearchType] = useState('')
  const [forceUpdate, setForceUpdate] = useState(false)
  const [userModalVisible, setUserModalVisible] = useState(false)
  const [selectedUser, setSelectedUser] = useState({})
  const [lockNavigation, setLockNavigation] = useState(true)

  const blockNavigationRef = useRef(null)

  const fetchLotteries = async (page, searchText, status, digitsSearchType, roundDate) => {
    const params = new URLSearchParams()
    params.append('page', page)

    searchText = searchText.length === 6 ? searchText : '......'
    params.append('number', `${searchText}`)

    if (status) {
      params.append('status', status)
    }

    if (roundDate) {
      params.append('roundDate', roundDate)
    }

    try {
      dispatch({ type: 'loading_show' })
      const requestUrl = `${configs.apiAdminGateway}/api/v2/admin/lotteries?${params.toString()}&isPublish=true`
      const getAccessToken = Cookies.get('accessToken')
      const myHeaders = new Headers()
      myHeaders.append('Authorization', `Bearer ${getAccessToken}`)
      myHeaders.append('Content-Type', 'application/json')
      fetch(requestUrl, { method: 'GET', headers: myHeaders })
        .then((response) => response.json())
        .then(async (result) => {
          setLotteries(result.data)
          dispatch({ type: 'loading_hide' })
        })
    } catch (err) {
      setLotteries([])
      dispatch({ type: 'loading_hide' })
    }
  }

  const closeSideMenuOnLivePage = () => {
    const toggle = document.querySelector('.nav-control')
    const menu = document.querySelector('#main-wrapper').classList
    const isActive = menu.contains('menu-toggle')

    if (toggle && !isActive) {
      toggle.click()
    }
  }

  useEffect(() => {
    closeSideMenuOnLivePage()
  }, [dispatch])

  useEffect(() => {
    blockNavigationRef.current = history.block((location, action) => {
      if (lockNavigation) {
        Swal.fire({
          icon: 'warning',
          title: 'คำเตือน',
          text: 'คุณต้องการออกจากหน้านี้หรือไม่',
          showCancelButton: true,
          confirmButtonText: 'ใช่',
          cancelButtonText: 'ไม่ใช่',
          reverseButtons: true,
        }).then((result) => {
          if (result.isConfirmed) {
            blockNavigationRef.current()
            history.push(location.pathname)
          }
        })
        return false
      }
    })

    return () => {
      blockNavigationRef.current()
    }
  }, [history, lockNavigation])

  const onChangePage = (page) => {
    setCurrentPage(page)
  }

  const handleOnChange = (e) => {
    e.preventDefault()
    fetchLotteries(currentPage, searchText, status, digitsSearchType, roundDate)
  }

  const clearSearch = () => {
    setSearchText('')
    setDigitsSearchType('')
    setStatus('ALL')
    setCurrentPage(1)
    setForceUpdate(!forceUpdate)
    setLotteries([])
  }

  return (
    <Fragment>
      <Card>
        <Card.Header>
          <Card.Title>Lotteries</Card.Title>
          <Card.Title className="float-right">
            <button
              type="button"
              className={`btn ${lockNavigation ? 'btn-primary' : 'btn-danger'}`}
              onClick={() => {
                setLockNavigation((prev) => !prev)
              }}
            >
              <span className={`fa ${lockNavigation ? 'fa-lock' : 'fa-unlock-alt'}`}></span>
            </button>
          </Card.Title>
        </Card.Header>
        <Card.Body>
          <Search
            setSearchText={setSearchText}
            handleOnChange={handleOnChange}
            searchText={searchText}
            setDigitsSearchType={setDigitsSearchType}
            setForceUpdate={setForceUpdate}
            forceUpdate={forceUpdate}
            digitsSearchType={digitsSearchType}
            clearSearch={clearSearch}
            fetchLotteries={fetchLotteries}
            roundDate={roundDate}
            status={status}
            setCurrentPage={setCurrentPage}
            currentPage={currentPage}
          />
          <LotteryList lotteries={lotteries} />
          <Pagination
            currentPage={currentPage}
            onPrevPage={() => onChangePage(currentPage - 1)}
            onNextPage={() => onChangePage(currentPage + 1)}
            items={lotteries}
            perPage={20}
          />
          <UserInfo lotteries={lotteries} />
        </Card.Body>
      </Card>
      {userModalVisible && (
        <UserModal
          userModalVisible={userModalVisible}
          setUserModalVisible={setUserModalVisible}
          selectedUser={selectedUser}
          setSelectedUser={setSelectedUser}
          onClose={() => {
            setUserModalVisible(false)
          }}
        />
      )}
    </Fragment>
  )
}

export default LotteryLive
